export default "__VITE_ASSET__9oYt$qTj__"